const MS_TEAMS = {
  SEND_PERK_NOTIFICATION:
    'Click here to send a notification about this perk to your Microsoft Teams.',
  NO_TEAMS_FOUND:
    'No teams found, please create some public teams with public channels in your Microsoft Teams account.',
  NO_CHANNELS_FOUND:
    'No public channels found in selected team, please selected another team or create some public channels and try again.',
  MS_CONNECTION_NOT_ALLOWED:
    'MS Connection is not allowed, please request admin and try again later.',
  ERROR_OCCURRED: 'Error occurred while processing microsoft auth request.',
  SELECT_TEAM:
    'Please select team to continue to send a notification to microsoft teams.',
  SELECT_CHANNEL:
    'Please select channel to continue to send a notification to microsoft teams.',
  NOT_IN_MS_TEAMS: 'Initialization Failed. No Parent window found.',
  ENABLE_INTEGRATION:
    'Please enable microsoft teams integration to use this feature.',
  ID_TOKEN_REQUIRED:
    'ID Token is required to complete the MS Teams SSO Auth Request.',
  ACCESS_TOKEN_EXPIRED:
    'Access Token Expired, please open perkforce app in ms teams again to refresh your access token.',
  TEAM_ID_IS_REQUIRED:
    'Team Id is required to fetch the channels for that team.',
  TEAM_CHANNEL_ID_IS_REQUIRED:
    'Team & Channel Id is required to send notification message to the channel.',
  MESSAGE_SENDING_FAILED:
    'Error occurred while sending the message to channel in MS Teams, please try again.',
  ADAPTIVE_CARD_FAILED:
    'Error Occurred while creating adaptive card to send message to MS Teams.',
  NOT_ALLOWED: 'You are not allowed to use MS Teams feature.',
  INVALID_DATA:
    'No valid data found for requested MS Teams action, please try again.',
  ERROR_WHILE_SENDING_NOTIFICATION:
    'Error occurred while sending notification to MS Teams.',
  NOTIFICATION_SENT: 'Notification sent successfully.',
  CONNECTED:
    "Congrats! You're now connected to Microsoft Teams.\nNow each perk has a feature where you can notify your Microsoft Teams channels about it. 🚀",
  DISCONNECTED:
    "You're now disconnected from Microsoft Teams.\nReconnect anytime to access its amazing features again.",
  ENABLED:
    'Microsoft Teams is enabled again!\nAll its amazing features are ready for you to enjoy.',
  DISABLED:
    "Microsoft Teams is disabled.\nYou're still connected, so turning it back on is easy whenever you're ready!",
} as const;

export default MS_TEAMS;
